import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import Landing from '@/modules/Landing/routes'
import Builder from '@/modules/Builder/routes'
import Resume from '@/modules/Resume/routes'
import Admin from '@/modules/Admin/routes'

const routes: RouteRecordRaw[] = [
  ...Landing,
  ...Builder,
  ...Resume,
  ...Admin,
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/layout/NotFoundView.vue'),
    meta: {
      title: "Sahifa topilmadi — cvLab",
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, saved) {
    if (saved) return saved
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

import { trackPageView } from '@/composables/useAnalytics'

router.afterEach(to => {
  if (to.meta.title) document.title = to.meta.title as string
  const d = document.querySelector('meta[name="description"]')
  if (d && to.meta.description) d.setAttribute('content', to.meta.description as string)

  // Track page view
  if (typeof window !== 'undefined') {
    trackPageView(to.path, (to.meta.title as string) || (to.name as string))
  }
})

export default router
